export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./contacts.vue?vue&type=template&id=ffb0a72a&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/contacts.vue?vue&type=template&id=ffb0a72a&
// module id = 1627
// module chunks = 0